import DefaultBlock from "/scripts/default/block";
import gsap from "gsap";
import { DrawSVGPlugin } from "gsap/all";
import { ScrollTrigger } from "gsap/all";
import { watchPreferredMotion } from "/utils/helpers/watchPreferredMotion";

gsap.registerPlugin(DrawSVGPlugin, ScrollTrigger);

export default class CoreConnect extends DefaultBlock {
	init() {
		const flair = this.block.querySelector(".core-connect__grid");
		this.flair = flair;

		const el = {
			dots: this.block.querySelectorAll("#core-connect-dots circle"),
			fills: this.block.querySelectorAll("#core-connect-fill path"),
			strokes: this.block.querySelectorAll("#core-connect-stroke path"),
			clip: this.block.querySelector("#core-connect-clip"),
		};
		this.el = el;

		this.initCoreConnect();
	}

	setConnect() {
		gsap.set(this.el.strokes, {
			drawSVG: "100% 0%",
		});

		gsap.set(this.el.clip, {
			scaleY: 0,
		});

		gsap.set(this.el.dots, {
			autoAlpha: 1,
			scale: 1,
		});

		watchPreferredMotion(() => {
			gsap.set(this.el.strokes, {
				transformOrigin: "100% 0%",
			});

			gsap.set(this.el.strokes, {
				drawSVG: "0% 0%",
			});

			gsap.set(this.el.clip, {
				scaleY: 1,
			});

			gsap.set(this.el.dots, {
				autoAlpha: 0,
				scale: 0,
				transformOrigin: "50% 50%",
			});
		});
	}

	dotsConnect() {
		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: this.flair,
				start: "top center",
			},
		});

		watchPreferredMotion(() => {
			tl.to(this.el.dots, {
				autoAlpha: 1,
				scale: 1,
				duration: 0.5,
				stagger: {
					grid: [6, 5],
					from: "center",
					amount: 0.3,
					ease: "power2.out",
				},
			})
				.to(
					this.el.strokes,
					{
						drawSVG: "100% 0%",
						ease: "power3.inOut",
						duration: 1.25,
					},
					">-0.3"
				)
				.to(
					this.el.clip,
					{
						scaleY: 0,
						duration: 1,
						ease: "power2.inOut",
					},
					">-0.5"
				);
		});
	}

	initCoreConnect() {
		this.setConnect();
		this.dotsConnect();
	}
}
